import type { Extraction, ExtractionResult } from "../types/extraction";
import {
  pickExtractionNdaData,
  stripLegacyDealNda,
} from "./extractionNda";

export function buildExtractionResult(
  extractionData: Extraction,
): ExtractionResult {
  const tenantColumnRanges =
    (extractionData as any)?.tenant_column_ranges ||
    (extractionData.deal_data as any)?.tenant_column_ranges ||
    [];

  const isInitialMaterials = Boolean(
    extractionData.is_initial_materials ??
      extractionData.metadata?.is_initial_materials,
  );
  const isTermSheet = Boolean(
    extractionData.is_term_sheet ?? extractionData.metadata?.is_term_sheet,
  );

  const dealRaw = (extractionData.deal_data || {}) as Record<string, unknown>;
  const deal = stripLegacyDealNda(dealRaw) as ExtractionResult["deal"];
  const nda = pickExtractionNdaData(extractionData);

  return {
    id: extractionData.id,
    fileName: extractionData.file_name,
    fileExtension: extractionData.file_extension,
    excelProvider: extractionData.excel_provider,
    deal,
    assets: extractionData.asset_data || [],
    tenantData: extractionData.tenant_dataframe || [],
    tenantColumnRanges,
    attachmentIndex: (extractionData as any)?.attachment_index ?? 0,
    assetNames: (extractionData.asset_data || [])
      ?.map((asset: any) => asset?.asset_name)
      .filter(Boolean),
    matchedAssets: (extractionData as any)?.matched_assets || null,
    dealId: extractionData.deal_id || null,
    usedForDeal:
      extractionData.used_for_deal ?? extractionData.deal_id != null,
    isTermSheet,
    isInitialMaterials,
    nda,
  };
}
